type Messages = Record<string, string>;

const messages: Messages = {
  'City.Default.label': 'City',
  'Comment.Default.label': 'Comments',
  'Companyname.Default.label': 'Company Name',
  'Costcenter.Default.label': 'Cost Centre',
  'Country.Default.label': 'Country',
  'Users.departmentname.label': 'Department Name',
  'Users.departmentnumber.label': 'Department Number',
  'Users.displayname.label': 'Display Name',
  'Email.Default.label': 'Email',
  'EmployeeClass.Default.label': 'Employee Class',
  'EmployeeID.Default.label': 'Employee ID',
  'EmployeeType.Default.label': 'Employee Type',
  'Entity.Default.label': 'Entity',
  'FirstName.Default.label': 'First Name',
  'JobCode.Default.label': 'Job Code',
  'JobCodeDesc.Default.label': 'Job Code Desc',
  'JobDescription.Default.label': 'Job Description',
  job_function: 'Job Function',
  'LastName.Default.label': 'Last Name',
  'leaveStatus.Default.label': 'Leave Status',
  'Location.Default.label': 'Location',
  'LocationDesc.Default.label': 'Location Desc',
  'LocationNumber.Default.label': 'Location Number',
  'Manager.Default.label': 'Manager',
  'Middlename.Default.label': 'Middle Name',
  'OrgunitID.Default.label': 'Orgunit ID',
  'Users.owner.label': 'Owner',
  'ownerOnTerminate.Default.label': 'Owner on Terminate',
  'PhoneNumber.Default.label': 'Phone Number',
  'PreferedFirstName.Default.label': 'Preferred First Name',
  'Region.Default.label': 'Region',
  'RegionCode.Default.label': 'Region Code',
  'secondaryEmail.Default.label': 'Secondary Email',
  'secondaryManager.Default.label': 'Secondary Manager',
  'secondaryPhone.Default.label': 'Secondary Phone',
  'siteId.label': 'Site ID',
  'State.Default.label': 'Locked State',
  'Users.statuskey.label': 'Status',
  'Street.Default.label': 'Street',
  'SystemUserName.Default.label': 'System Username',
  'Title.Default.label': 'Title',
  'UserName.Default.label': 'Username',
  'Vendor.Manager': 'Organization Owner',
  'Users.CustomProperty1.Default.label': 'Custom Property 1',
  'Users.CustomProperty2.Default.label': 'Custom Property 2',
  'Users.CustomProperty3.Default.label': 'Custom Property 3',
  'Users.CustomProperty4.Default.label': 'Custom Property 4',
  'Users.CustomProperty5.Default.label': 'Custom Property 5',
  'Users.CustomProperty6.Default.label': 'Custom Property 6',
  'Users.CustomProperty7.Default.label': 'Custom Property 7',
  'Users.CustomProperty8.Default.label': 'Custom Property 8',
  'Users.CustomProperty9.Default.label': 'Custom Property 9',
  'Users.CustomProperty10.Default.label': 'Custom Property 10',
  'Users.CustomProperty11.Default.label': 'Custom Property 11',
  'Users.CustomProperty12.Default.label': 'Custom Property 12',
  'Users.CustomProperty13.Default.label': 'Custom Property 13',
  'Users.CustomProperty14.Default.label': 'Custom Property 14',
  'Users.CustomProperty15.Default.label': 'Custom Property 15',
  'Users.CustomProperty16.Default.label': 'Custom Property 16',
  'Users.CustomProperty17.Default.label': 'Custom Property 17',
  'Users.CustomProperty18.Default.label': 'Custom Property 18',
  'Users.CustomProperty19.Default.label': 'Custom Property 19',
  'Users.CustomProperty20.Default.label': 'Custom Property 20',
  'Users.CustomProperty21.Default.label': 'Custom Property 21',
  'Users.CustomProperty22.Default.label': 'Custom Property 22',
  'Users.CustomProperty23.Default.label': 'Custom Property 23',
  'Users.CustomProperty24.Default.label': 'Custom Property 24',
  'Users.CustomProperty25.Default.label': 'Custom Property 25',
  'Users.CustomProperty26.Default.label': 'Custom Property 26',
  'Users.CustomProperty27.Default.label': 'Custom Property 27',
  'Users.CustomProperty28.Default.label': 'Custom Property 28',
  'Users.CustomProperty29.Default.label': 'Custom Property 29',
  'Users.CustomProperty30.Default.label': 'Custom Property 30',
  'Users.CustomProperty31.Default.label': 'Custom Property 31',
  'Users.CustomProperty32.Default.label': 'Custom Property 32',
  'Users.CustomProperty33.Default.label': 'Custom Property 33',
  'Users.CustomProperty34.Default.label': 'Custom Property 34',
  'Users.CustomProperty35.Default.label': 'Custom Property 35',
  'Users.CustomProperty36.Default.label': 'Custom Property 36',
  'Users.CustomProperty37.Default.label': 'Custom Property 37',
  'Users.CustomProperty38.Default.label': 'Custom Property 38',
  'Users.CustomProperty39.Default.label': 'Custom Property 39',
  'Users.CustomProperty40.Default.label': 'Custom Property 40',
  'Users.CustomProperty41.Default.label': 'Custom Property 41',
  'Users.CustomProperty42.Default.label': 'Custom Property 42',
  'Users.CustomProperty43.Default.label': 'Custom Property 43',
  'Users.CustomProperty44.Default.label': 'Custom Property 44',
  'Users.CustomProperty45.Default.label': 'Custom Property 45',
  'Users.CustomProperty46.Default.label': 'Custom Property 46',
  'Users.CustomProperty47.Default.label': 'Custom Property 47',
  'Users.CustomProperty48.Default.label': 'Custom Property 48',
  'Users.CustomProperty49.Default.label': 'Custom Property 49',
  'Users.CustomProperty50.Default.label': 'Custom Property 50',
  'Users.CustomProperty51.Default.label': 'Custom Property 51',
  'Users.CustomProperty52.Default.label': 'Custom Property 52',
  'Users.CustomProperty53.Default.label': 'Custom Property 53',
  'Users.CustomProperty54.Default.label': 'Custom Property 54',
  'Users.CustomProperty55.Default.label': 'Custom Property 55',
  'Users.CustomProperty56.Default.label': 'Custom Property 56',
  'Users.CustomProperty57.Default.label': 'Custom Property 57',
  'Users.CustomProperty58.Default.label': 'Custom Property 58',
  'Users.CustomProperty59.Default.label': 'Custom Property 59',
  'Users.CustomProperty60.Default.label': 'Custom Property 60',
  'Users.CustomProperty61.Default.label': 'Custom Property 61',
  'Users.CustomProperty62.Default.label': 'Custom Property 62',
  'Users.CustomProperty63.Default.label': 'Custom Property 63',
  'Users.CustomProperty64.Default.label': 'Custom Property 64',
  'Users.CustomProperty65.Default.label': 'Custom Property 65',
  CREATOR: 'Created By',
  'Users.PrimaryOrganization.label': 'Primary Organization',
  'Users.EnddateInUTC.Default.label': 'End Date (UTC)',
  'Users.StartdateInUTC.Default.label': 'Start Date (UTC)',
  'Users.TermdateInUTC.Default.label': 'Term Date (UTC)',
  'Users.LastLoginDateInUTC.Default.label': 'Application Last Login Date (UTC)',
};

export default messages;
